<script>
import MsgList from './MsgList';

export default {
  name: 'MsgListForHecto',
  extends: MsgList,
  data() {
    return {
      isHectoBrand: true
    };
  },
  methods: {
    // new methods
    closeChatRoomForHecto() {
      if (!this.chatRoomId) return false;
      this.$http({
        method: 'POST',
        url: '/api/external/webchat/closeChatRoom',
        data: {
          chatRoomId: this.chatRoomId
        }
      }).then((res) => {
        if (res.data.code !== 0) {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
          });
        } else {
          if (res.data.data && res.data.data.url) {
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: `<dl class="txt"><dt>설문조사하기</dt><dd class="autoScroll">${res.data.data.description}</dd></dl>`,
              getBtnCount: 2,
              getCloseBtnName: '다음에 할래요',
              getBtnName: '참여하기',
              getCloseButtonEvent: () => {
                window.localStorage.removeItem('showHectoKeyboard');
                window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
                window.sessionStorage.removeItem('CURRENTLY_CHATROOM');
                this.isEnd = true;
              },
              getButtonEvent: () => {
                window.localStorage.removeItem('showHectoKeyboard');
                window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
                window.sessionStorage.removeItem('CURRENTLY_CHATROOM');
                this.isEnd = true;
                this.$mitt.emit('windowOpen', {
                  url: res.data.data.url,
                  target: 'urlWindow',
                  features: 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=no'
                });
              }
            });
          }
        }
      });
    },

    // override methods
    clickedCategory(item, type, index) {
      if (this.chatRoomId === undefined) {
        return;
      }
      if (item.type === 'URL') {
        if (item.data === '이용 약관 보기') {
          this.$mitt.emit('windowOpen', {
            url: item.code,
            target: 'urlWindow',
            features: 'toolbar=no,menubar=no,resizeable=1,width=400,height=300'
          });
          return;
        } else if (item.data === '개인정보 수집 및 이용약관 확인하기') {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: `<dl class="txt"><dt>개인정보 수집 및 이용약관</dt>
                      <dd class="autoScroll">(주)헥토이노베이션에서는 원활한 상담을 위하여 다음과 같이 고객님의 개인정보를 처리 합니다. </dd></dl>
                      <br />
                      <ul class="lineAligns">
                        <li>이용 목적 : 회원 식별/상담 등 원활한 상담을 위한 정보 활용</li>
                        <li>수집 항목 : 휴대폰 번호</li>
                        <li>보유 기간 : 고객 상담 완료 이후 12개월 혹은 법정 보유기간</li>
                        <li>수탁 업체 : 더화이트커뮤니케이션(주)</li>
                        <li>위탁 업체 : (주)헥토이노베이션</li>
                        <li>위탁 업무 : 채팅 기반 상담 서비스 제공</li>
                      </ul>`,
            getBtnCount: 1,
            getBtnName: '확인'
          });
          return;
        } else {
          this.$mitt.emit('windowOpen', {
            url: item.pcUrl || item.mobileUrl,
            target: 'urlWindow',
            features: 'height=' + screen.height + ',width=' + screen.width + 'fullscreen=yes'
          });
          return;
        }
      }
      let content = {};

      if (type === 'COMBINATION') {
        content = { text: item.data, code: item.code };
      } else {
        content = { code: item.code, text: item.text };
      }
      if (type === 'SCENARIO' || type === 'COMBINATION') {
        this.scenarioData[index] = item.code;
        window.sessionStorage.setItem('SCENARIO_CHECK_DATA', JSON.stringify(this.scenarioData));
      }

      this.loading = true;
      if (item.channelName === 'NAVER_TALK' || item.channelName === 'KAKAO_TALK' || item.channelName === 'FACEBOOK_TALK') {
        if (navigator.userAgent.indexOf(this.brandQuery.appId) === -1) {
          this.windowPopup = window.open('about:blank', '_blank');
        }
      }

      // 헥토이노베이션 커스텀
      if (item.type === 'CHAT_BOT_AUTHENTICATION') {
        content = { text: item.data, code: item.code, type: 'CHAT_BOT_AUTHENTICATION' };
      }

      this.$http({
        method: 'POST',
        url: '/api/external/webchat/sendMessage',
        data: {
          senderUid: this.uuid,
          chatRoomId: this.chatRoomId,
          messageType: type,
          scenarioTemplateCode: type === 'COMBINATION' ? '' : item.code,
          content: JSON.stringify(content)
        }
      })
        .then((res) => {
          if (res.data.code !== 0) {
            if (this.isNotAvailable(res.data)) return;
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
            });

            if (this.isHectoBrand) {
              this.closeChatRoomForHecto();
            }
          }
        })
        .catch((errorMsg) => {
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + errorMsg + '</dd></dl>'
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // override methods
    checkImage(chat) {
      return (
        (this.headerStyle && this.headerStyle.toolbarAgentIconPath) ||
        'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_chatbot_v2.png'
      );
    },

    // override methods
    getCustomCombinationTitle(content) {
      try {
        const jsonContent = JSON.parse(content);
        return jsonContent && jsonContent.title;
      } catch (e) {
        return null;
      }
    }
  }
};
</script>
<style lang="scss">
.msgCon .sendBox .inp {
  position: relative;
  padding: 4px 10px 4px 10px;
  width: 100%;
  transition: all 0.3s ease-in-out;

  .box input {
    position: relative;
    z-index: 1;
    padding: 0 0 0 10px;
    vertical-align: top;
    width: 100%;
    height: 37px;
    min-height: 37px;
    max-height: 102px;
    line-height: 22px;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
    -webkit-backface-visibility: hidden;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    outline: none;
    overflow: auto;
    background: transparent 0 0;
    font-size: 14px;
    resize: none;
    &:focus,
    &:active {
      outline: none;
    }
    &::placeholder {
      color: #bdbdbd;
    }
  }
}
</style>
